import { AppInfo } from './AppInfo';
import { oemConfig } from './OEMConfig';

/**
 * Application - Main application orchestrator
 */
export class Application {
  /**
   * Display application version in the navbar
   */
  public static displayVersion(): void {
    const versionSpan = document.querySelector('.navbar .font-semibold');
    if (versionSpan) {
      // Check if we're on mobile (screen width < 640px, which is Tailwind's sm breakpoint)
      const isMobile = window.innerWidth < 640;
      versionSpan.textContent = isMobile ? '' : oemConfig.getBrandName();
      
      // Update on window resize
      window.addEventListener('resize', () => {
        const isMobileNow = window.innerWidth < 640;
        versionSpan.textContent = isMobileNow ? '' : oemConfig.getBrandName();
      });
    }
  }

  /**
   * Initialize sidebar collapse functionality
   */
  public static initSidebarCollapse(): void {
    const btn = document.getElementById("collapse-btn");
    btn?.addEventListener("click", () => {
      document.body.classList.toggle("sidebar-collapsed");
    });
  }
}
